class UserRole {
  constructor(userRoleData = {}) {
    this.id = userRoleData.id || null;
    this.name = userRoleData.name || "";
    this.key = userRoleData.key || "";
  }
}

export default UserRole;
